import { Controller } from '@hotwired/stimulus';
import { TextAreaController } from '@elc-online/edl-components/js/textarea';

export default class extends Controller {
  static readonly targets = ['input', 'display'];

  declare inputTarget: HTMLTextAreaElement;
  declare displayTarget: HTMLElement;

  initialize() {
    new TextAreaController(
      { limit: this.displayTarget, textarea: this.inputTarget },
      { mode: 'auto' },
    );
  }
}
